import React from 'react';
import { Image, Shimmer } from 'react-shimmer'

export default class SearchArticlesVideoListItem extends React.Component {
  render() {
    return (
      <a className="search-results__item" href={this.props.video.url}>
        <Image
          src={this.props.video.image_url}
          fallback={<Shimmer width={56} height={40} />}
          errorFallback={() => (
            <Shimmer width={56} height={40} />
          )}
          NativeImgProps={{ className: 'search-results__thumbnail', alt: this.props.video.title }}
        />
        <div className="search-results__item-content">
          <div className="search-results__item-title">{this.props.video.title}</div>
          <div className="search-results__item-subtitle">{this.props.video.content}</div>
        </div>
      </a>
    );
  }
}
